/**
 * Per-doctor consultation plan wire shape (table: catalog.doctor_plans).
 * BE module: apps/admin/src/modules/doctor-plans.
 *
 * Phase E Cycle 4 — `type` is the canonical PlanType string
 * ('video_call' | 'report'). `features` is jsonb stored as `string[]`.
 * FE form keeps it as a comma-separated string in the textarea and
 * splits at the boundary. `lang` is the per-locale row scope.
 */

// Phase E Cycle 4 canonical (BE catalog.constants).
export enum PlanType {
  VideoCall = 'video_call',
  Report = 'report'
}

export enum PlanStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export interface DoctorPlanInput {
  name: string;
  description: string;
  price: number;
  type?: PlanType;
  duration?: number;
  features?: string[];
  lang?: string;
}

export interface DoctorPlan {
  id: number;
  name: string;
  description: string;
  price: number;
  type: PlanType;
  duration: number | null;
  features: string[] | null;
  lang: string;
}
